import React, { lazy, Suspense, useMemo } from "react";

const Snowfall = lazy(() => import("react-snowfall"));

export const SnowProvider = ({ children }: React.PropsWithChildren) => {
  const shouldShowSnowfall = useMemo(() => {
    if (typeof window === "undefined") return false;

    const now = new Date();
    const currentMonth = now.getMonth();
    const currentDay = now.getDate();

    const showFromDay = 15;
    const showToDay = 11;

    return (
      (currentMonth === 11 && currentDay >= showFromDay) ||
      (currentMonth === 0 && currentDay <= showToDay)
    );
  }, []);

  if (!shouldShowSnowfall) {
    return children;
  }
  return (
    <>
      <Suspense fallback={null}>
        <Snowfall
          style={{
            position: "fixed",
            width: "100vw",
            height: "100vh",
            zIndex: 1000,
          }}
        />
      </Suspense>
      {children}
    </>
  );
};
